<template>
  <router-view/>
</template>

<script>
export default {
  name: 'Pembiayaan'
}
</script>
